import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import Image from "../../asset/img/Logo/logo.png";
import Image2 from "../../asset/img/SingleProduct/1.png";
import EmptyCart from "../../asset/img/Order/cart.png";
import { useCartContext } from "../Context/UserContext";
import { Link } from "react-router-dom";
import { MdDelete } from "react-icons/md";
import Button from "../Common/Button";
import Footer2 from "../Common/Footer/index2";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { environment } from "../../environment/environment";
import { City, Country, State } from "country-state-city";
import Select from "react-select";

const Finalpayment = () => {
  const { cart, setCart } = useCartContext();
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedState, setSelectedState] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);
  const [selectedPin, setSelectedPin] = useState(null);
  const [pinOptions, setPinOptions] = useState();
  const [Loading, setLoading] = useState(false);
  const user_country = selectedCountry?.name;
  const user_state = selectedState?.name;
  const user_city = selectedCity?.name;
  const user_pincode = selectedPin?.Pincode;

  let size = cart.length;

  const {
    register,
    handleSubmit,
    setValue,
    trigger,
    reset,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    setLoading(true);
    const purchase_price = cart[0].purchase_price;
    const product_quantity = cart[0].product_quantity;
    // Combine form data with cart details
    const payload = {
      ...data,
      cart,
      user_total_amount: total,
      user_country,
      user_state,
      user_city,
      user_pincode,
      purchase_price,
      product_quantity,
    };
    // localStorage payload
    localStorage.setItem("order_payload", JSON.stringify(payload));

    try {
      const response = await axios.post(
        `${environment?.API_BASE_URL}/users/create-order`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response?.data?.success) {
        window?.open(response?.data?.url);
        setLoading(false);
        // Reset cart and form
        setCart([]);
        reset();
      } else {
        // Handle unexpected response status+
        toast.error("Something went wrong. Please try again.");
      }
    } catch (error) {
      setLoading(false);
      console.error(
        "Error during order submission:",
        error.response?.data || error.message
      );
      toast.error("Failed to place the order. Please try again later.");
    }
  };

  const getAllCodesByCity = async (city) => {
    const response = await axios.get(
      `https://api.postalpincode.in/postoffice/${city}`
    );

    if (response?.data[0]?.Status === "Success")
      setPinOptions(
        response?.data[0]?.PostOffice ? response?.data[0]?.PostOffice : "na"
      );
  };

  const subtotal = cart.reduce(
    (acc, item) => acc + item.product_price * item.product_quantity,
    0
  );
  const total = subtotal;

  const removeFromCart = async (item) => {
    const product_id = localStorage.getItem("product_id");

    try {
      const response = await axios.delete(
        `${environment?.API_BASE_URL}/users/removecart?product_id=${product_id}&user_id=${item?.user_id}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response) {
        setCart((prevCart) =>
          prevCart.filter((i) => i.user_id !== item?.user_id)
        );
        toast.success("Item removed from cart successfully!");
      } else {
        toast.error("Failed to remove item from cart. Please try again.");
      }

      const getCart = JSON.parse(sessionStorage.getItem("cart"));

      // Using filter()
      const filteredArray = getCart.filter((i) => i.user_id !== item.user_id);

      // Using splice()
      getCart.splice(
        getCart.findIndex((i) => i.user_id === item.user_id),
        1
      );

      // Update localStorage with the modified cart
      sessionStorage.setItem("cart", JSON.stringify(filteredArray));
    } catch (error) {
      console.error(
        "Error removing item from cart:",
        error.response?.data || error.message
      );
      toast.error("Something went wrong. Please try again later.");
    }
  };

  const updateQuantity = async (index, change) => {
    try {
      // Optimistically update the cart
      const updatedCart = cart.map((item, i) => {
        if (i === index) {
          const updatedQuantity = Math.max(item.product_quantity + change, 1);
          return {
            ...item,
            product_quantity: updatedQuantity,
            product_total_amount: item.product_price * updatedQuantity, // Correct total amount calculation
          };
        }
        return item;
      });

      // Save the original cart for rollback
      const originalCart = [...cart];

      // Update local state and localStorage
      setCart(updatedCart);
      sessionStorage.setItem("cart", JSON.stringify(updatedCart));

      const updatedItem = updatedCart[index];
      const { product_id, user_id, product_quantity, product_total_amount } =
        updatedItem;

      // API call to sync with the server
      const response = await axios.post(
        `${environment?.API_BASE_URL}/users/updateCartItem`,
        {
          product_id: localStorage?.getItem("product_id"),
          user_id,
          product_quantity,
          product_total_amount,
          change,
        }
      );

      toast.success("Quantity updated successfully!");
    } catch (error) {
      console.error("Error updating quantity:", error);

      // Revert the optimistic update on failure
      setCart(cart);
      sessionStorage.setItem("cart", JSON.stringify(cart));
      toast.error("Failed to update quantity. Please try again later.");
    }
  };

  const calculateTotalQuantity = () => {
    return cart?.reduce((acc, item) => acc + item.product_quantity, 0);
  };
  const Iteam = calculateTotalQuantity();

  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={true}
        closeOnClick
        pauseOnHover
      />
      <div className="final-pay">
        <div className="container-fluid">
          {size === 0 ? (
            <div className="py-5">
              <div>
                <h3 className="text-center">- : Your Basket is Empty : -</h3>
              </div>
              <div className="d-flex justify-content-center my-5">
                <h5>
                  {/* <FontAwesomeIcon icon={faCartShopping} /> */}
                  <img
                    src={EmptyCart}
                    alt="Loading"
                    className="rounded mx-auto d-block w-75"
                  />
                </h5>
              </div>
              <Link to="/singleproduct" className="text-center d-block mt-3">
                {/* <button className="btn btn-primary">Go Back to Shopping</button> */}
                <Button title="Go Back to Shopping" />
              </Link>
            </div>
          ) : (
            <>
              <div className="row">
                <div className="col-lg-6 col-md-12 py-3 background-color-pullman-green">
                  <div className="order-input px-4">
                    <form
                      onSubmit={handleSubmit(onSubmit)}
                      className="p-4 border rounded-3 lh-lg"
                      style={{
                        maxWidth: "600px",
                        margin: "0 auto",
                      }}
                    >
                      <label className="text-white fw-bold pb-3">
                        BASIC DETAIL
                      </label>
                      <input
                        className="w-100 px-3 py-2 border rounded-1"
                        {...register("user_name", {
                          required: true,
                          pattern: {
                            value: /^[A-Za-z\s]+$/,
                            message: "Only alphabets are allowed",
                          },
                        })}
                        placeholder="FULL NAME"
                      />
                      {errors.user_name && (
                        <p className="text-light mb-0">
                          {errors.user_name.message || "This field is required"}
                        </p>
                      )}
                      <input
                        type="email"
                        className="input w-100 mt-2 px-3 py-2 border rounded-1"
                        {...register("user_email")}
                        placeholder="E-MAIL"
                      />
                      {errors.user_email && (
                        <p className="text-light mb-0">
                          This field is required
                        </p>
                      )}

                      <input
                        className="w-100 mt-2 px-3 py-2 border rounded-1"
                        type="tel"
                        // {...register("user_mobile_num", { required: true })}
                        {...register("user_mobile_num", {
                          required: true,
                          pattern: {
                            value: /^\d{10}$/,
                            message:
                              "Please enter a valid 10-digit mobile number",
                          },
                        })}
                        placeholder="MOB NO."
                      />
                      {errors.user_mobile_num && (
                        <p className="text-light mb-0">
                          This field is required
                        </p>
                      )}

                      <label className="text-white fw-bold py-2">
                        DELIVERY
                      </label>

                      <input
                        className="w-100 mt-2 px-3 py-2 border rounded-1"
                        {...register("user_house_number", { required: true })}
                        placeholder="HOUSE NO. / COLONY"
                      />
                      {errors.user_house_number && (
                        <p className="text-light mb-0">
                          This field is required
                        </p>
                      )}

                      <input
                        className="w-100 mt-2 px-3 py-2 border rounded-1"
                        {...register("user_landmark", { required: true })}
                        placeholder="STREET / LANDMARK"
                      />
                      {errors.user_landmark && (
                        <p className="text-light mb-0">
                          This field is required
                        </p>
                      )}
                      <div className="row d-flex justify-content-between">
                        <div className="col-lg-6 col-md-6">
                          <Select
                            options={Country?.getAllCountries()}
                            getOptionLabel={(options) => {
                              return options["name"];
                            }}
                            getOptionValue={(options) => {
                              return options["name"];
                            }}
                            onChange={(item) => {
                              setSelectedCountry(item);
                              setValue("user_country", item?.name || "");
                              trigger("user_country");
                            }}
                            name="country"
                            placeholder="COUNTRY"
                            className="mob-input mt-2 py-1"
                          />
                          <input
                            type="hidden"
                            {...register("user_country", { required: true })}
                          />
                          {errors.user_country && (
                            <p className="text-light mb-0">
                              This field is required
                            </p>
                          )}
                        </div>

                        <div className="col-lg-6 col-md-6">
                          <Select
                            options={State?.getStatesOfCountry(
                              selectedCountry?.isoCode
                            )}
                            getOptionLabel={(options) => {
                              return options["name"];
                            }}
                            getOptionValue={(options) => {
                              return options["name"];
                            }}
                            onChange={(item) => {
                              setSelectedState(item);
                              setValue("user_state", item?.name || "");
                              trigger("user_state");
                            }}
                            name="state"
                            placeholder="STATE"
                            className="state-input mt-2 py-1 w-100"
                          />
                          <input
                            type="hidden"
                            {...register("user_state", { required: true })}
                          />
                          {errors.user_state && (
                            <p className="text-light mb-0">
                              This field is required
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="row d-flex justify-content-between">
                        <div className="col-lg-6 col-md-6">
                          <Select
                            options={City.getCitiesOfState(
                              selectedState?.countryCode,
                              selectedState?.isoCode
                            )}
                            getOptionLabel={(options) => {
                              return options["name"];
                            }}
                            getOptionValue={(options) => {
                              return options["name"];
                            }}
                            onChange={(item) => {
                              setSelectedCity(item);
                              getAllCodesByCity(item.name);
                              setValue("user_city", item?.name || "");
                              trigger("user_city");
                            }}
                            name="city"
                            placeholder="CITY"
                            className="city-input mt-2 py-1"
                          />
                          <input
                            type="hidden"
                            {...register("user_city", { required: true })}
                          />
                          {errors.user_city && (
                            <p className="text-light mb-0">
                              This field is required
                            </p>
                          )}
                        </div>
                        <div className="col-lg-6 col-md-6">
                          <Select
                            options={pinOptions}
                            isDisabled={!pinOptions}
                            getOptionLabel={(option) => {
                              return option.Pincode;
                            }}
                            getOptionValue={(option) => option.value}
                            value={selectedPin}
                            onChange={(item) => {
                              setSelectedPin(item);
                              setValue("user_pincode", item); // Update form state
                            }}
                            placeholder="PIN"
                            className="pin-input mt-2 py-1"
                          />
                          <input
                            type="hidden"
                            {...register("user_pincode", {
                              required: true,
                              pattern: {
                                value: /^\d{6}$/,
                                message:
                                  "Please enter a valid 10-digit mobile number",
                              },
                            })}
                          />
                          {errors.user_pincode && (
                            <p className="text-light mb-0">
                              {errors.user_pincode?.message ||
                                "This field is required"}
                            </p>
                          )}
                        </div>
                      </div>

                      <div className="d-flex align-items-center justify-content-center pt-4">
                        <button
                          type="submit"
                          className="w-50 border rounded-pill text-uppercase button-feedback d-flex align-items-center justify-content-center"
                          disabled={Loading}
                        >
                          <span className="me-2">Pay Now</span>
                          <span
                            className={`${Loading ? "spinner" : "d-none"}`}
                          ></span>
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
                <div className="col-lg-6 col-md-12">
                  <div className="final-price">
                    <div className="order-logo m-auto">
                      <img src={Image} alt="Product" className="w-100 h-100" />
                    </div>

                    <div className="product-table mt-5">
                      <table className="table table-striped table-bordered text-center">
                        <tbody>
                          {cart.map((item, index) => (
                            <tr key={index} className="align-middle">
                              <td>
                                <img
                                  src={item.image || Image2}
                                  alt="Product"
                                  style={{ width: "60px", height: "60px" }}
                                />
                              </td>
                              <td>Gir Cow Ghee ({item.product_weight})</td>
                              <td>
                                <div className="quantity-controls d-flex align-items-center justify-content-center">
                                  <button
                                    className="btn btn-outline-secondary btn-sm"
                                    onClick={() => updateQuantity(index, -1)}
                                    disabled={item.product_quantity <= 1}
                                  >
                                    -
                                  </button>
                                  <span className="mx-3">
                                    {item.product_quantity}
                                  </span>
                                  <button
                                    className="btn btn-outline-secondary btn-sm"
                                    onClick={() => updateQuantity(index, 1)}
                                  >
                                    +
                                  </button>
                                </div>
                              </td>
                              <td>₹ {item.product_price}</td>
                              <td>
                                <button
                                  className="btn btn-danger btn-sm"
                                  onClick={() => removeFromCart(item)}
                                >
                                  <MdDelete />
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    <div className="d-flex justify-content-between mt-1">
                      <p className="fs-5 ms-4">Subtotal :-</p>
                      <p className="fw-normal me-4">₹{subtotal}</p>
                    </div>
                    <div className="d-flex justify-content-between mt-1">
                      <p className="fs-5 ms-4"> Item:-</p>
                      <p className="fw-normal me-4">{Iteam}</p>
                    </div>
                    <div className="d-flex justify-content-between lh-1 mt-1">
                      <p className="fs-5 ms-4">Shipping Charges</p>
                      <p className="fw-normal me-4">Free</p>
                    </div>
                    <div className="d-flex justify-content-between lh-1 mt-1">
                      <p className="fs-5 fw-bold ms-4">Total</p>
                      <p className="fw-normal me-4">₹{total}</p>
                    </div>
                    <p className="lh-1 ms-4">
                      (Including all services and taxes)
                    </p>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
      <Footer2 />
    </>
  );
};

export default Finalpayment;
